import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { loadAgencyProducerInformations } from '~/api/data/agencies/queries';
import { loadExcelSpreadsheetTemplates } from '~/api/data/excel-templates/queries';
import { loadCustomForms } from '~/api/data/forms/queries';
import { loadHtmlDocumentTemplates } from '~/api/data/html-templates/queries';
import { loadCurrentUser, loadUserProducerInformations } from '~/api/data/users/queries';
import { loadWordDocumentTemplates } from '~/api/data/word-templates/queries';
import { shouldRevalidateWorkspace } from '~/api/data/workspaces/revalidation';
import { loadCaraWorkspace } from '~/api/data/workspaces/queries';
import { CopilotWorkspacesPage } from '~/pages/workspaces/copilot-workspaces';
import { CopilotWorkspacePage } from '~/pages/workspaces/workspace';

export const workspaceRoutes: RouteObject[] = [
  {
    path: 'workspaces',
    element: <CopilotWorkspacesPage />
  },
  {
    path: 'workspaces/archived',
    element: <CopilotWorkspacesPage archived />
  },
  {
    path: 'workspaces/:id',
    shouldRevalidate: shouldRevalidateWorkspace,
    loader: merge({
      agencyProducerInformations: loadAgencyProducerInformations,
      agencyUser: loadCurrentUser,
      caraWorkspace: loadCaraWorkspace,
      customForms: loadCustomForms,
      htmlDocumentTemplates: loadHtmlDocumentTemplates,
      userProducerInformations: loadUserProducerInformations,
      wordDocumentTemplates: loadWordDocumentTemplates,
      excelSpreadsheetTemplates: loadExcelSpreadsheetTemplates
    }),
    element: <CopilotWorkspacePage />
  }
];
